import React, { useEffect, useState } from "react";
import TrainingListIndex from "./TrainingListIndex";
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const TrainingListLanding = () => {
    const [loginId, setLoginId] = useState('');

    useEffect(() => {
        let id = localStorage.getItem("userId");
        setLoginId(id);
    }, []);

    console.log(loginId !== '' ? "heeeeeeeeeeeeeeeeeeee" : "meeeeeeeeeeeeeeeeeeee");

    return (
        <>
            {loginId !== '' ? (
                <>
                    <IdleTimeOutHandler />
                    <TrainingListIndex />
                    {console.log("Inside <IdleTimeOutHandler /> and <TrainingListIndex /> block")}
                </>
            ) : (
                <>
                    <TrainingListIndex />
                    {console.log("Inside <TrainingListIndex /> block")}
                </>
            )}
        </>
    )
}

export default TrainingListLanding;
